import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Hombres y mujeres con trabajos físicos (construcción, limpieza, jardinería, transporte).', 'Conductores de camiones o Uber que pasan horas sentados con dolor sordo.', 'Personas que sienten hormigueo, debilidad o "corrientazos" en las piernas.', 'Cualquier persona en USA que necesite recuperarse rápido sin gastar miles en especialistas.'];
const notForWho = ['Personas que buscan una cura mágica sin dedicar 4 minutos al día a los ejercicios.', 'Personas con fracturas vertebrales recientes o traumas graves que requieren cirugía inmediata.'];
export function AudienceSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-7">
      <div className="max-w-5xl mx-auto" data-id="element-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-9">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-green/5 rounded-2xl p-8 border border-green/20" data-id="element-10">
            <h3 className="font-heading font-bold text-2xl text-charcoal mb-6 flex items-center" data-id="element-11">
              <span className="bg-green text-white rounded-full p-1 mr-3" data-id="element-12">
                <Check className="w-5 h-5" data-id="element-13" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-14">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-15">
                  <Check className="w-5 h-5 text-green mr-3 mt-1 flex-shrink-0" data-id="element-16" />
                  <span className="font-body text-warm-gray leading-relaxed" data-id="element-17">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-crimson/5 rounded-2xl p-8 border border-crimson/20" data-id="element-18">
            <h3 className="font-heading font-bold text-2xl text-charcoal mb-6 flex items-center" data-id="element-19">
              <span className="bg-crimson text-white rounded-full p-1 mr-3" data-id="element-20">
                <X className="w-5 h-5" data-id="element-21" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-22">
              {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-23">
                  <X className="w-5 h-5 text-crimson mr-3 mt-1 flex-shrink-0" data-id="element-24" />
                  <span className="font-body text-warm-gray leading-relaxed" data-id="element-25">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}